module.exports = __webpack_public_path__ + "static/img/logo09.beb5896.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo09.jpg
// module id = afrV
// module chunks = 1